import { Injectable } from '@angular/core';
import { DateTime } from 'luxon';

@Injectable({
  providedIn: 'root'
})
export class DateConverterService {

  private quarterToMonth = {'1': 1, '2': 4, '3': 7, '4': 10 };
  private abrvToMonth = {
    'jan': 1, 'feb': 2, 'mar': 3, 'apr': 4, 'may': 5, 'jun': 6,
    'jul': 7, 'aug': 8, 'sep': 9, 'oct': 10, 'nov': 11, 'dec': 12
  };
  private yearPrfx = '20';

  private dateRegexs = {
    '([1-4])Q(\\d\\d)': (match) => DateTime.fromObject({year: Number(`${this.yearPrfx}${match[2]}`), month: this.quarterToMonth[match[1]]}),
    'YE(\\d\\d)': (match) => DateTime.fromObject({year: Number(`${this.yearPrfx}${match[1]}`), month: 12}),
    '([1-2])H(\\d\\d)': (match) => DateTime.fromObject({year: Number(`${this.yearPrfx}${match[2]}`), month: match[1] === '1' ? 1 : 6}),
    'MY(\\d\\d)': (match) => DateTime.fromObject({year: Number(`${this.yearPrfx}${match[1]}`), month: 6}),
    '([a-zA-Z][a-z][a-z])\\s?(\\d\\d)': (match) => DateTime.fromObject({
      year: Number(`${this.yearPrfx}${match[2]}`),
      month: this.abrvToMonth[match[1].toLowerCase()]
    }),
  };

  constructor() { }

  public specificDate(d: string): DateTime {
    for (const [reg, datefn] of Object.entries(this.dateRegexs)) {
      const match = d.match(new RegExp(reg));
      if (match) {
        return datefn(match);
      }
    }
    return DateTime.now();
  }

  public isValidDateFormat(d: string): boolean {
    const regexs = Object.keys(this.dateRegexs);
    return new RegExp(regexs.join('|')).test(d);
  }
}
